import React, { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import ProgressSimple from "components/common/Loading";
import LoginPage from "pages/LoginPage";

const isDevelopment = process.env.NODE_ENV === "development";

const AuthGuard = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (isDevelopment) {
    if (location.pathname === "/auth") {
      return <Navigate to="/" replace={true} />;
    }

    return <>{children}</>;
  }

  if (!auth.isInitialized) {
    return <ProgressSimple />;
  }

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <LoginPage />;
  }

  if (location.pathname === "/auth") return <Navigate to="/" replace={true} />;
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} replace={true} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.any,
};

export default AuthGuard;
